import axios from "axios";
import {
  requestInterceptor,
  responseSuccessInterceptor,
  responseFailInterceptor,
  requestTransformer,
} from "./http.config";

/**
 * Creating the instance of Axios
 **/
const httpClient = axios.create({});

/**
 * Axios configurations
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
httpClient.defaults.headers["X-Requested-With"] = "XMLHttpRequest";
httpClient.defaults.headers["Cache-Control"] = "no-cache,no-store";
httpClient.defaults.headers.post["Content-Type"] = "application/json";

/** Request will be aborted if longer that timeout, default is `0` */
httpClient.defaults.timeout = 0;

/** No redirects will be followed, we will handle redirect manually */
httpClient.defaults.maxRedirects = 0;

httpClient.defaults.transformRequest = [requestTransformer];

/** Adding the request interceptors */
httpClient.interceptors.request.use(requestInterceptor);

/** Adding the response interceptors */
httpClient.interceptors.response.use(
  (response) => responseSuccessInterceptor(response),
  (error) => responseFailInterceptor(error, httpClient),
);

/**
 * Utility method to mock a json response
 * */
export function mock(responseData) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        code: "ok",
        data: responseData,
      });
    }, 500);
  });
}

export default httpClient;
